import {data} from "azure-maps-control";

import type {MapMouseEvent} from "azure-maps-control";
import type {Map} from "@esWebAPI/es/map"
import type {IEventChannel, OverlayFeatureClickEvent} from "@esWebAPI/es/model/Models";

/**
 * @class TemporaryPointControl
 * todo: rename from TemporaryPointControl to PointControl? It's used whether the point is temporary or not
 */
export default class TemporaryPointControl {
    private loc: string;

    private map: Map;
    private style;
    private isShowSalesforceOptions: boolean;
    private isDirections: boolean;

    // note: true when a "normal" persisted point and false when it's a temporary/non-persisted point
    private isPersistedAddressPoint: boolean;

    private filterControl;
    private temporaryPointDiv: JQuery<HTMLElement>;
    private isToolActive: boolean;
    private isAddingPoint: boolean;
    private overlayId: number | null;
    private popupId: number | null;

    /**
     * 
     * @param map
     * @param element
     * @param style
     * @param isShowSalesforceOptions
     * @param isDirections
     * @param isAddressPoint is true if User owns map and there is no analysis
     * @param elementClickOverride
     */
    constructor(map: Map, element: JQuery<HTMLElement>, style, isShowSalesforceOptions: boolean, isDirections: boolean, isAddressPoint: boolean, elementClickOverride?: Function) {
        this.loc = es.util.TrackingEvents.getLocation(window.location.href);

        this.map = map;
        this.style = style;
        this.isShowSalesforceOptions = isShowSalesforceOptions;
        this.isDirections = isDirections;
        this.isPersistedAddressPoint = isAddressPoint;

        this.filterControl = null;

        this.temporaryPointDiv = $('<div />').addClass("temporaryPointDiv ui-front");
        es.api.style.generateView(style, 35, 35).done((image) => this.temporaryPointDiv.html(image));

        this.isToolActive = false;
        this.isAddingPoint = false;
        this.overlayId = null;
        this.popupId = null;

        this.setFilterControl = this.setFilterControl.bind(this);
        this.setStyle = this.setStyle.bind(this);
        this.doStart = this.doStart.bind(this);
        // private TS methods, so we can use bind to facilitate usage in callbacks (otherwise they can get TypeError: Cannot read private member)
        this.onOverlayFeatureClick = this.onOverlayFeatureClick.bind(this);
        this.defaultElementClick = this.defaultElementClick.bind(this);
        this.onUserPlacedPoint = this.onUserPlacedPoint.bind(this);
        this.followTheCursor = this.followTheCursor.bind(this);
        this.waitForActive = this.waitForActive.bind(this);

        map.baseMap.imageSpriteManager.addFromStyle(style);

        map.eventChannel.addListener('onOverlayFeatureClick', this.onOverlayFeatureClick);

        element.on('click', elementClickOverride ? elementClickOverride : this.defaultElementClick);
    }

    /**
     * 
     * @param filterControl 
     */
    setFilterControl(filterControl) {
        this.filterControl = filterControl;
    }

    /**
     * 
     * @param newStyle 
     */
    setStyle(newStyle) {
        this.style = newStyle;

        es.api.style.generateView(this.style, 35, 35).done((image) => this.temporaryPointDiv.html(image));
    }

    /**
     * 
     */
    doStart() {
        // Check if we are inEditMode to ask the user to whether cancel current edit or create new TempPoint
        esApp.map.select.confirmRevertEdit().then(() => {
            if (this.isToolActive) {
                this.deactivatePoint();
            } else {
                this.activatePoint();
            }
        });
    }

    /**
     * 
     * @param lonLatPnt 
     * @param addressString 
     * @param overlayFeat 
     * 
     * @returns 
     */
    private temporaryPopupContent(lonLatPnt: [number, number], addressString: string, overlayFeat?: data.Feature<data.Geometry, any>): JQuery<HTMLElement> {
        // can barely see the address with this
        // var element = $("<div/>", {"class" : "es-select-info-main"}).append(
        //     $("<div/>").addClass("es-control-SelectInfo-label-container").append(
        //         $("<div/>", {"class": "es-control-SelectInfo-label-main onlyLabel", "title": addressString}).append(
        //             $("<div/>", {"class": "es-control-SelectInfo-label-main-text"}).append(
        //                 $("<span/>").text(addressString)
        //     )))
        // );

        let label = addressString || "";
        let tooltip = addressString || "";
        if (overlayFeat?.properties) {
            if(overlayFeat.properties.name && overlayFeat.properties.address){
                label = overlayFeat.properties.name + ", " + overlayFeat.properties.address + "\n";
                tooltip = "";
            }

            //let propsHtml = "";
            const propKeysWeWant = ["name", "address", "categories", "phone", "url"];
            for (const key in overlayFeat.properties) {
                if(propKeysWeWant.includes(key)){
                    const val = overlayFeat.properties[key];

                    tooltip += key.toTitleCase() + ": " + val + "\n";
                    // todo: build up the extra info in the info panel?
                    // propsHtml +=
                    //     '<div class="es-control-edit-attr-STRING">' +
                    //         '<label title="' + key + '">' + key + '</label>' +
                    //         '<div class="es-control-edit-attr-previewText" title="' + val + '">' + val + '</div>' +
                    //     '</div>';
                }
            }
            // element.append('<hr/><div class="es-select-info-options"><div><div class="es-control-edit-FeatureAttrControl-content">' + propsHtml + '</div></div></div>');
        }

        const element = $("<div/>", {"class" : "es-select-info-main"}).append(
            $("<div/>").addClass("es-control-SelectInfo-label-container").append(
                $("<div/>").addClass("es-control-SelectInfo-label-main onlyLabel").css("cursor", "pointer").attr('title', tooltip).text(label)
            )
        );

        element.append('<hr><div class="es-select-info-options"><div class="es-select-info-nearest" title="' + $i18n('Nearest') +
            '"><div class="es-select-info-nearest-img unselectable">&#9608;</div><span class="es-select-info-options-text">' + $i18n('Nearest') +
            '</span></div><div class="es-select-info-distance" title="' + $i18n('Radius') +
            '"><div class="es-select-info-distance-img unselectable">&#9608;</div><span class="es-select-info-options-text">' + $i18n('Radius') +
            '</span></div><div class="es-select-info-zoom" title="' + $i18n('Zoom') +
            '"><div class="es-select-info-zoom-img unselectable">&#9608;</div><span class="es-select-info-options-text">' + $i18n('Zoom') + '</span></div>');

        element.find(".es-select-info-options").append('<div class="es-select-info-streetView" title="' + $i18n('Street_View') + '"><div class="es-select-info-streetView-img unselectable">&#9608;</div></div>');

        if (this.isShowSalesforceOptions) {
            // filter dataset dropdown
            const salesforceCreateDropdown = $("#es-select-salesforce-create");
            salesforceCreateDropdown.off("show").on("show", () => {
                const list = salesforceCreateDropdown.find("ul");
                list.empty();
                const types = ["Lead", "Contact"];
                types.forEach((item) => {
                    list.append($("<li />").data("type", item).text(item));
                });
            });

            salesforceCreateDropdown.off("click").on("click", "li", (event) => {
                var type = $(event.target).data("type");
                if (es.isDeveloper) {
                    es.log.info("You selected the type" + type);
                }
                es.SFDC.client.extractDataForNewTempPointSalesforceObject(type, addressString);
            });

            element.find(".es-select-info-options")
                .append('<div class="es-select-info-create-salesforce" title="' + $i18n('Create_New') + '"  data-dropdown="#es-select-salesforce-create">' +
                    '<div class="es-select-info-CreateNew-img unselectable">&#9608;</div>' +
                    '<span class="es-select-info-options-text">' + $i18n('Create_New') + '</span>' +
                    '<span class="es-select-info-createNew-icon"></span>' +
                    '</div>');
        }

        if (this.filterControl) {
            element.find('.es-select-info-nearest').on('click', () => {
                es.util.TrackingEvents.push([ this.loc + '.SI.Add_Nearest_Filter']);

                var layerView = this.map.layer.getById(this.filterControl.getLayerViewId());
                Promise.all([
                    layerView.getCriteriaObjRef() ? false : es.api.layerView.hasCriteriaFeatureSource(layerView.getId()), // if has criteria, doesn't matter if layerview has criteria
                    this.map.meta.getAnalysisId() ? es.api.analysis.get(this.map.meta.getAnalysisId()) : null
                ]).then(([hasCriteriaFeatureSource, analysis]) => {
                    if (analysis && analysis.$type == 'AggregateByAttributeAnalysis' && layerView.getId() == analysis.generatedAggregateLayerViewId) {
                        es.alert.alertOk($i18n('_Filter_Error_AggregateByAttribute_Aggregate_Dataset_Active'));

                        return;
                    }

                    if (layerView.getCriteriaObjRef() || hasCriteriaFeatureSource) {
                        es.alert.alertOk($i18n('_Nearest_Filter_Error_Already_Has_Filter'));

                        return;
                    }

                    this.filterControl.createSpatialFilter("Nearest", ['PT', lonLatPnt[0], lonLatPnt[1]]);
                });
            });

            element.find('.es-select-info-distance').on('click', () => {
                es.util.TrackingEvents.push([this.loc + '.SI.Add_Within_Filter']);

                var layerView = this.map.layer.getById(this.filterControl.getLayerViewId());
                (this.map.meta.getAnalysisId() ? es.api.analysis.get(this.map.meta.getAnalysisId()) : Promise.resolve(null)).then((analysis) => {
                    if (analysis && analysis.$type == 'AggregateByAttributeAnalysis' && layerView.getId() == analysis.generatedAggregateLayerViewId) {
                        es.alert.alertOk($i18n('_Filter_Error_AggregateByAttribute_Aggregate_Dataset_Active'));

                        return;
                    }

                    this.filterControl.createSpatialFilter("WithinDistance", ['PT', lonLatPnt[0], lonLatPnt[1]]);
                });
            });
        } else {
            element.find('.es-select-info-distance, .es-select-info-nearest').css("display", "none");
        }

        element.find('.es-select-info-zoom').on('click', () => {
            es.util.TrackingEvents.push([this.loc + '.SI.Zoom_To_Here']);

            this.map.baseMap.setCenterAndResolution(lonLatPnt[0], lonLatPnt[1], 1.2);
        });

        element.find('.es-select-info-streetView').on('click', () => {
            es.util.TrackingEvents.push([this.loc + '.SI.StreetView']);

            es.util.google.openStreetView(lonLatPnt);
        });

        return element;
    }

    /**
     * 
     * @param event 
     */
    // using TS private instead of JS private so we can use bind
    private onOverlayFeatureClick(event: OverlayFeatureClickEvent) {
        if (this.overlayId !== event.shape.id) {
            return;
        }

        this.temporaryPointClicked(event.position, event.shape.properties.address, event.shape);
    }

    /**
     * 
     * @param event 
     */
    // using TS private instead of JS private so we can use bind
    private defaultElementClick(event: Event) {
        if (!this.isDirections) {
            event.stopPropagation();
        }

        this.doStart();
    }

    /**
     * 
     */
    private removePoint() {
        this.map.overlay.remove(this.overlayId);
        this.map.popup.remove(this.popupId);
        this.overlayId = null;
        this.popupId = null;
    }

    /**
     * 
     */
    private activatePoint() {
        es.util.TrackingEvents.push([this.loc + '.Header.Add_Temporary_Point']);
        if (this.overlayId){
            this.removePoint();
        }

        this.map.select.setSelectionEnabled(false);
        this.map.baseMap.map.events.add('click', this.onUserPlacedPoint);
        this.map.baseMap.map.events.add('mousemove', this.followTheCursor);

        $("body").append(this.temporaryPointDiv);
        this.isToolActive = true;
        // setting up on click event with setTimeout so that the current click being processed doesn't trigger waitForActive to be called
        window.setTimeout(() => $(document).on("click", this.waitForActive), 1);
        $(document).on("keydown", this.waitForActive);
    }

    /**
     * 
     */
    private deactivatePoint() {
        if (this.isToolActive) {
            this.map.select.setSelectionEnabled(true);
            this.map.baseMap.map.events.remove('click', this.onUserPlacedPoint);
            this.map.baseMap.map.events.remove('mousemove', this.followTheCursor);

            $(this.temporaryPointDiv).detach();
            this.isToolActive = false;
            this.isAddingPoint = false;
        }
        $(document).off("click", this.waitForActive);
        $(document).off("keydown", this.waitForActive);
    }

    /**
     * 
     */
    // using TS private instead of JS private so we can use bind
    private waitForActive() {
        if (this.isToolActive) { // if the point is active
            setTimeout(() => !this.isAddingPoint && this.deactivatePoint(), 300); // wait in case it was a click on the map, and them try to deactivate the temporary point
        }
    }

    /**
     * Update the point location on the screen
     * 
     * @param event
     */
    // using TS private instead of JS private so we can use bind
    private followTheCursor(event: MapMouseEvent) {
        if (event.pixel) {
            //console.log("followTheCursor", event.pixel);
            const diffLeft = -5;
            const diffTop  = es.isPublicAccess ?  3 : 63;
            this.temporaryPointDiv.css({
                left: event.pixel[0] + diffLeft,
                top:  event.pixel[1] + diffTop
            });
        }
    }

    /**
     *
     * @param event
     */
    // using TS private instead of JS private so we can use bind
    private onUserPlacedPoint(event: MapMouseEvent) {
        const diffLeft = -2;
        // no idea what's going on with this offset. it shouldn't need to be different to the followTheCursor one but doesn't look right
        const diffTop  = !this.isPersistedAddressPoint ? -15: 0;
        let adjustedPixel = [
            event.pixel[0] + diffLeft,
            event.pixel[1] + diffTop
        ];
        let adjustedPosition = this.map.baseMap.fromPx(adjustedPixel);
        this.addPoint(adjustedPosition);
    }

    /**
     *
     * @param location latLon
     */
    private addPoint(location: [number, number]) {
        if (this.isToolActive){
            this.isAddingPoint = true;
            es.api.geocode.reverseGeocode(location).then((address) => {
                let dfd = es.util.deferred.resolved();
                
                if (!this.isPersistedAddressPoint) {
                    const props = {
                        suppressEvents: true,
                        address: address,
                        id: -1,
                        name: address,
                    };

                    this.overlayId = this.map.overlay.add(new data.Point(location), this.style, undefined, props);
                } else {
                    dfd = this.onEventOrTimeout(this.map.eventChannel, "onCreatedAddressPoint", 1000); // point creation is detached, through onAddAddressPoint event and a onCreatedAddressPoint is fired on complete (1 sec timeout as it can fail and no created is fired... should be enough to create layer and add point)
                    
                    this.map.eventChannel.fireEvent("onAddAddressPoint", {point: location, address: address, name:''});
                }

                this.map.popup.clear();

                if (this.isDirections && !this.isPersistedAddressPoint) {
                    const stop = {
                        id: this.overlayId,
                        layerviewId: -1,
                        label: address,
                        geom: ["PT", location[0], location[1]]
                    };

                    this.map.eventChannel.fireEvent('onTemporaryAddStop', stop);  // use for directions page
                }

                if (!this.isPersistedAddressPoint) {
                    this.temporaryPointClicked(location, address)
                }

                dfd.done(() => this.deactivatePoint());
            });
        }
    }

    /**
     *
     */
    private onEventOrTimeout(eventChannel: IEventChannel, eventType: string, timeout: number) {
        const dfd = $.Deferred();
        
        let t;
        
        const evtListener = () => {
            clearTimeout(t);
            eventChannel.removeListener(eventType, evtListener);
            
            dfd.resolve(true);
        };
        eventChannel.addListener(eventType, evtListener);
        
        t = setTimeout(() => {
            eventChannel.removeListener(eventType, evtListener);
            
            dfd.resolve(false);
        }, timeout);
        
        return dfd.promise();
    }

    /**
     *
     * @param {[number, number]} lonLatPnt
     * @param {string} address
     * @param {data.Feature} overlayFeat
     */
    private temporaryPointClicked(lonLatPnt: [number, number], address: string, overlayFeat?: data.Feature<data.Geometry, any>) {
        this.map.popup.clear(); // remove any other pop ups that where open

        const popupHeight = 100;
        const popupWidth = es.isEmbeddedInSFDC ? 450 : 400;

        this.overlayId = overlayFeat?.id || this.overlayId;
        if (overlayFeat?.properties?.clickFn){
            overlayFeat.properties.clickFn();
        }

        this.popupId = this.map.popup.add({
            content: this.temporaryPopupContent(lonLatPnt, address, overlayFeat),
            location: lonLatPnt,
            popupSize: [popupWidth, popupHeight],
            offsetPx: [0, 20],
            closeBtnSelector: "es-select-temp-point-close-x"
        });

        this.map.baseMap.ensurePixelBoundsVisible(this.map.popup.getPixelBounds(this.popupId));

        const closePopup = () => {
            this.map.popup.remove(this.popupId);
        };

        this.map.eventChannel
            .addListener("onShowListFeatures", closePopup)
            .addListener("onSelectFeature", closePopup);

        const deleteBtn = $("<div/>").addClass("es-control-edit-FeatureAttrControl-deleteBtn unselectable")
            .attr("title", $i18n("Delete_Temporary_Point")).on('click', () => {
                this.removePoint();
            });

        deleteBtn.insertBefore(this.map.popup.getContentElement(this.popupId).find(".es-map-popup-closeBtn"));
    }
}
